import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import Icons from "@/assets";

interface AccessibilityGuideProps {
  open: boolean;
  onClose: () => void;
}

const data = [
  {
    color: "green",
    label: "Green (Fully accessible)",
    desc: "Both Entry and Exit are accessible",
  },
  {
    color: "gold",
    label: "Yellow (Partially accessible)",
    desc: "Only Entry or Exit is accessible",
  },
  {
    color: "red",
    label: "Red (Not accessible)",
    desc: "Neither Entry nor Exit is accessible",
  },
  {
    color: "grey",
    label: "Grey (No data)",
    desc: "No contribution verified by moderator or no contributions yet",
  },
];

const AccessibilityGuide: React.FC<AccessibilityGuideProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: "6px", p: "1%", width: "89.5%", maxWidth: "100vw" },
      }}
    >
      <DialogContent>
        {/* Logo */}
        <Box
          sx={{
            height: { xs: "11.99vw", sm: 49 },
            width: { xs: "39.59vw", sm: 163 },
            m: "0 auto 2% auto",
          }}
        >
          <img
            src={Icons.Logo}
            alt="logo"
            style={{ height: "100%", width: "100%" }}
          />
        </Box>

        {/* Description */}
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ fontSize: 14, mb: "2%" }}
        >
          Here is a quick guide to understand the color-coded accessibility
          labels shown on the map
        </Typography>

        {/* Color legend */}
        <Stack>
          {data.map((item) => (
            <Box
              key={item.color}
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ mt: "4.37vw" }}
            >
              <Box>
                <Box
                  sx={{
                    width: { xs: "3.88vw", sm: 20 },
                    height: { xs: "3.88vw", sm: 20 },
                    borderRadius: "50%",
                    backgroundColor: item.color,
                  }}
                />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                  {item.label}
                </Typography>

                <Typography sx={{ fontSize: 14 }}>{item.desc}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>

        {/* Button */}
        <Box sx={{ textAlign: "center", mt: "8%" }}>
          <Button
            variant="contained"
            sx={{
              background: "linear-gradient(90deg, #8a2be2, #6a5acd)",
              borderRadius: "30px",
              px: 4,
              fontSize: 16,
              textTransform: "none",
            }}
            onClick={onClose}
          >
            Let's Go
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AccessibilityGuide;
